import CityPageTemplate from "../city-template/CityPageTemplate";
import { laPlataConfig } from "./data";

export default function LaPlataPage() {
  return <CityPageTemplate config={laPlataConfig} />;
}